module.exports = __webpack_public_path__ + "572af86ec4a7a8e24c5caa54c9c34328.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/ConvenienceStoreInstruction/assets/ic-info.svg
// module id = 1624
// module chunks = 1